import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createApiClient } from '../client';
import { useAuth } from '../../auth/useAuth';

export function useReorderChapter(bookId: string | undefined) {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      id,
      newSequenceOrder,
    }: {
      id: string;
      newSequenceOrder: number;
    }) => {
      const client = createApiClient(getToken);
      await client.put(`api/v2/chapters/${id}/reorder`, {
        json: { newSequenceOrder },
      });
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['chapters', bookId] }),
  });
}
